import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ItemsEmpty from 'components/ItemsEmpty'
import Item from './components/Item'
import './style.css'



export default class Items extends Component {
    static propTypes = {
        ids: PropTypes.arrayOf(PropTypes.string).isRequired,
        byId: PropTypes.shape({
            [PropTypes.string]: PropTypes.shape.isRequired
        }).isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            currentItemId: null
        }
    }

    componentWillReceiveProps(nextProps) {
        // hide current editing item form on adding new item
        if (nextProps.ids.length > this.props.ids.length) {
            this.setState({
                currentItemId: null
            })
        }
    }

    onItemEditingClick(id) {
        this.setState({
            currentItemId: id
        })
    }


    render() {
        if (this.props.ids.length) {
            return (
                <ul>
                    { this.props.ids.map(itemId => <Item
                        key={itemId}
                        {...this.props.byId[itemId]}
                        onItemEditing={(id) => this.onItemEditingClick(id)}
                        currentItemId={this.state.currentItemId} />)
                    }
                </ul>
            )
        }

        return <ItemsEmpty />
    }
}
